import React, { forwardRef } from "react";
import { useTheme } from "@mui/material/styles";

export const Card = forwardRef(function CardComponent(
    { children, width, height, style = {}, ...rest },
    ref
) {
    const theme = useTheme();

    const cardStyle = {
        ...style,
        flex: 1,
        backgroundColor: "#ffffff",
        padding: "20px",
        borderRadius: "12px",
        border: `1px solid ${theme?.palette?.neutral?.[100] || "#e0e0e0"}`, // fallback in case `neutral` is undefined
        width: width || "100%",
        marginTop: "20px",
        height: height || "auto",
    };

    return (
        <div ref={ref} style={cardStyle} {...rest}>
            {children}
        </div>
    );
});

export const CardContainer = ({ children, columns = 1 }) => {
    const containerStyle = {
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
    };

    const defaultCardWidth = `calc(${100 / columns}% - ${
        ((columns - 1) * 20) / columns
    }px)`;

    return (
        <div style={containerStyle}>
            {React.Children.map(children, (child) => {
                if (!React.isValidElement(child)) return child;
                const customWidth = child?.props?.width;
                const cardWidth = customWidth || defaultCardWidth;
                return React.cloneElement(child, { width: cardWidth });
            })}
        </div>
    );
};
